import { useState } from 'react';
import { Button } from '@wundo/ui';
import { AddMeetingDialog } from './AddMeetingDialog.tsx';
import { m } from '@/paraglide/messages.js';

export interface AddMeetingButtonProps {
  userId: string;
}

/**
 * "Gesprek toevoegen": the way a meeting gets onto the agenda when no calendar
 * put it there.
 *
 * Only ever rendered for somebody without a calendar — both the toolbar and the
 * empty state put it behind that gate — so the dialog always asks who the
 * conversation is with, and offers the people already known by name.
 *
 * The form itself is `AddMeetingDialog`, because this button is not its only
 * door: the chat drawer's first nudge opens the same one.
 */
export function AddMeetingButton({ userId }: AddMeetingButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button size='sm' variant='primary' onClick={() => setOpen(true)}>
        {m.agenda_add_meeting()}
      </Button>
      <AddMeetingDialog userId={userId} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
